import { render, staticRenderFns } from "./BolGoodsEdit.vue?vue&type=template&id=5c54744b&scoped=true"
import script from "./BolGoodsEdit.vue?vue&type=script&lang=js"
export * from "./BolGoodsEdit.vue?vue&type=script&lang=js"
import style0 from "./BolGoodsEdit.vue?vue&type=style&index=0&id=5c54744b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54744b",
  null
  
)

export default component.exports